"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseTitle } from "../ModalBase/ModalBaseTitle.mjs";
import { useModalContext } from "./Modal.context.mjs";
import Modal_module_default from "./Modal.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Modal/ModalTitle.tsx
const ModalTitle = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ModalTitle", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseTitle, {
		...useModalContext().getStyles("title", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
ModalTitle.classes = Modal_module_default;
ModalTitle.displayName = "@mantine/core/ModalTitle";
//#endregion
export { ModalTitle };

//# sourceMappingURL=ModalTitle.mjs.map